import { render, staticRenderFns } from "./ChildDepartmentDetailTable.vue?vue&type=template&id=3a0739d8&scoped=true&"
import script from "./ChildDepartmentDetailTable.vue?vue&type=script&lang=js&"
export * from "./ChildDepartmentDetailTable.vue?vue&type=script&lang=js&"
import style0 from "./ChildDepartmentDetailTable.vue?vue&type=style&index=0&id=3a0739d8&lang=scss&scoped=true&"
import style1 from "./ChildDepartmentDetailTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0739d8",
  null
  
)

export default component.exports